import React from "react";

const SiemensContext = () => {
  return (
    <div className="column-sections pb-20 siemens-case-study">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="column-content pb-40 text-left">
             
              <p>
              A Fortune 500 Manufacturing Conglomerate operating across 11+ regions and serving over 10 high-value sectors, including Automotive, Semiconductors, Aerospace, Energy, Electronics, and Consumer Products, Set out to sharpen its global go-to-market strategy.
              <br/>
             Despite the scale, the organization lacked clarity on which opportunities to prioritize, where to focus resources, and how to align marketing with frontline sales. The GTM engine was fully loaded: campaigns running, leads flowing, teams in motion.
             However, behind the activity, key questions remained unanswered: </p><p className="text-center"><span><b>"We’re generating leads. But which ones matter? Where do we double down? And how do we align marketing’s signal with sales reality, without creating more dashboards and meetings?"</b></span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiemensContext;
